module.exports = __webpack_public_path__ + "img/servers-icon-color.844ee254.svg";